<template>

    <div>

        <div class="d-flex mb-3 align-items-sm-center">
            <div class="flex-grow-0 mr-2" v-if="title">
                <span class="h5 ">{{ title }}</span>
            </div>

            <div v-if="actions && actions.length > 0 || filters && filters.length > 0" class="flex-grow-1 d-flex flex-wrap flex-sm-nowrap">
                <div v-if="filters && filters.length > 0"
                     class="mr-2 mr-sm-2 mb-2 mb-sm-0">
                    <b-button v-b-toggle="filtersDomId" variant="info">
                        <span><b-icon icon="funnel" /></span>
                    </b-button>
                </div>

                <div v-if="actions && actions.length > 0"
                     class="mr-2 mb-2 mb-sm-0 mr-sm-2">
                    <b-button-group>
                        <data-table-action v-for="action in actions"
                                           v-show="action.available"
                                           :name="action.name"
                                           :title="action.title"
                                           :variant="action.variant ? action.variant : 'info'"
                                           :show-title="action.showTitle"
                                           :icon="action.icon"
                                           :dropdown-list="action.dropdownList"
                                           :action="action"
                                           :emitted-event="actionEvents[action.name].event"
                                            @[actionEvents[action.name].event]="action.callback(
                                                $event,
                                                actionEvents[action.name].event + '-start',
                                                actionEvents[action.name].event + '-finish')">
                        </data-table-action>
                    </b-button-group>
                </div>

                <div class="flex-grow-1" v-if="search" >
                    <data-table-search v-on:search-term-changed="onSearchTermChanged"
                                       v-on:search-focus-changed="onSearchFocusChanged"
                                       :initial-value="getStoredSearch(name)"
                                       :placeholder="searchPlaceholder"
                                       :key="name + '-table-search'"/>
                </div>

            </div>

        </div>

        <b-collapse :id="filtersDomId" :visible="initialFiltersVisible">
            <div class="d-flex flex-wrap mb-3 bg-light rounded p-2 p-md-3 pb-3 pb-md-4">
                <div v-for="filter in getVisibleFilters()" :key="filter.name" class="col-xs-12 col-md-6 col-lg-4">
                    <data-table-filter :ref="filter.name" v-if="!filter.type || filter.type === 'list'"
                                       :filter="filter"
                                       :initial-value="getInitialFilters(filter.name)"
                                       v-on:filter-added="onFilterAdded"
                                       v-on:filter-removed="onFilterRemoved"/>
                    <data-table-date-filter :ref="filter.name" v-if="filter.type === 'date'"
                                            :filter="filter"
                                            v-on:filter-added="onFilterAdded"
                                            v-on:filter-removed="onFilterRemoved" />
                    <data-table-date-from-to-filter :ref="filter.name" v-if="filter.type === 'dateFromTo'"
                                                    :filter="filter"
                                                    :initial-value-from="getInitialDateFromFilter(filter.name)"
                                                    :initial-value-to="getInitialDateToFilter(filter.name)"
                                                    v-on:filter-added="onFilterAdded"
                                                    v-on:filter-removed="onFilterRemoved" />
                    <data-table-boolean-filter :ref="filter.name" v-if="filter.type === 'boolean'"
                                               :filter="filter"
                                               :initial-value="getInitialFilter(filter.name)"
                                               v-on:filter-added="onFilterAdded"
                                               v-on:filter-removed="onFilterRemoved" />
                </div>
            </div>
        </b-collapse>

        <slot name="extraActionControl">
        </slot>


        <div v-if="appliedFilters.length" class=" d-flex flex-column mb-5 ">
            <div class="d-flex flex-wrap mb-2">
                <div v-for="(v, i) in appliedFilters" :key="i + '-filters-applied'" class="mr-4 mb-1 d-flex align-items-center">
                    <span class="mr-1">{{ v.label }}</span>
                    <span><b-button class="text-button" @click="resetFilter(v.key, v.value, true, v.parentFilterName, v.linkValue)"><b-icon icon="x"/></b-button></span>
                </div>
            </div>
            <div><b-button variant="outline-primary" @click="resetAllFilters">Сбросить все</b-button></div>
        </div>

        <transition name="fade" appear mode="out-in">

            <div key="table-body" v-if="!loading && !noResults">
                <div class="position-relative overflow-auto mb-2"  v-dragscroll >
                    <table ref="table" class="table data-table" :key="name + '-table'" >
                        <thead>
                            <tr>
                                <th v-if="showSelectRowColumn">
                                    <b-checkbox @change="onToggleSelectAll" v-b-tooltip="'Выбрать все записи на этой странице'"/>
                                </th>
                                <th v-for="column in getVisibleColumns">
                                    <div class="d-flex align-items-center justify-content-start" :style="{ width: column.width }">
                                        <span v-if="orderingValues[column.name] !== undefined">
                                            <data-table-ordering v-model="orderingValues[column.name]"
                                                                 :column-name="column.name"
                                                                 :field-name="getOrderingFieldName(column.name)"
                                                                 @state-changed="onOrderingChanged" />
                                        </span>
                                        <span>{{ column.title }}</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="i in rows.length * 2"
                                :key="name + '-row-action-' + i + selectedKey"
                                :class="{ selected: getRowSelected(i)  }"
                                @contextmenu.prevent="i % 2 !== 0 ? openMenu($event, rows[(i - 1)/2]) : null">
                                <td :key="name + '-checkbox-' + i + selectedKey" :style="getCellStyle(i)" v-if="showSelectRowColumn">
                                    <b-checkbox @change="onToggleRowSelect"
                                                v-if="i % 2 !== 0"
                                                v-model="rows[(i - 1)/2].selected"/>
                                </td>
                                <td v-for="j in i % 2 !== 0 ? getVisibleColumns.length : 1"
                                    :key="j"
                                    :colspan="i % 2 !== 0 ? 0 : getVisibleColumns.length"
                                    :style="getCellStyle(i)">


                                    <div class="d-flex flex-wrap align-items-center w-100" v-if="i % 2 !== 0">
                                        <component :is="getVisibleColumns[j - 1].cellComponentName"
                                                   v-if="getVisibleColumns[j - 1].cellComponentName && getVisibleColumns[j - 1].cellComponentPath && !getVisibleColumns[j - 1].to"
                                                   :value="getRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1], true)"
                                                   :extra-value="getExtraRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1], true)"
                                                   :extra-props="getExtraPropsRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1], true)"
                                                   :modal-name="getVisibleColumns[j - 1].modal ? getVisibleColumns[j - 1].modal.modalName : null"
                                                   :row="rows[(i - 1)/2]"
                                                   @object-modal-triggered="showObjectModal">
                                        </component>
                                        <div class="d-flex flex-column" v-else-if="getVisibleColumns[j - 1].to">
                                            <link-cell :title="getRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1])"
                                                       :route-name="getVisibleColumns[j - 1].to.routeName"
                                                       :route-id="getRowColumnNameValue(rows[(i - 1)/2], getVisibleColumns[j - 1].to.idColumn)"
                                                       :prepend-with-n="getVisibleColumns[j - 1].to.prependWithN"
                                                       :restricted="getVisibleColumns[j - 1].to.restricted"/>
                                            <span class="text-secondary" v-if="getVisibleColumns[j - 1].extraDataFrom">
                                                {{ getExtraRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1], true) }}
                                            </span>
                                        </div>
                                        <div class="d-flex flex-column" v-else-if="getVisibleColumns[j - 1].modal">
                                            <modal-button-cell :title="getRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1])"
                                                               :modal-name="getVisibleColumns[j - 1].modal.modalName"
                                                               :object-id="getRowColumnNameValue(rows[(i - 1)/2], getVisibleColumns[j - 1].modal.idColumn)"
                                                               :prepend-with-n="getVisibleColumns[j - 1].modal.prependWithN"
                                                               @object-modal-triggered="showObjectModal"/>
                                            <span class="text-secondary" v-if="getVisibleColumns[j - 1].extraDataFrom">
                                                {{ getExtraRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1], true) }}
                                            </span>
                                        </div>
                                        <div class="d-flex flex-column" v-else>
                                            <div>{{ getRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1]) }}</div>
                                            <div>
                                                <span class="text-secondary" v-if="getVisibleColumns[j - 1].extraDataFrom">
                                                    {{ getExtraRowColumnValue(rows[(i - 1)/2], getVisibleColumns[j - 1], true) }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <b-collapse :id="'collapse-row-' + getRowColumnNameValue(rows[Math.floor((i - 1)/2)], 'id')" v-else>
                                        <component :is="toggleRowComponent.cellComponentName"
                                                   v-if="toggleRowComponent.cellComponentName && toggleRowComponent.cellComponentPath"
                                                   :object-id="rows[Math.floor((i - 1)/2)].id"
                                                   :object="rows[Math.floor((i - 1)/2)]"
                                                   :row="rows[(i - 1)/2]" />
                                    </b-collapse>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="col-12 text-secondary d-flex align-items-center flex-column flex-sm-row">
                    <div class="flex-grow-0"><span>Показано: {{ filteredObjectsCount }} из {{ totalObjectsCount }}</span></div>
                    <div class="flex-grow-1">
                        <data-table-pagination v-model="page"
                                               :key="name + '-pagination-top'"
                                               :page-count="pageCount"/>
                    </div>
                    <div class="flex-grow-0 mt-2"><data-table-page-size-select :table-name="name" @page-size-changed="onPageSizeChanged"/></div>
                </div>
            </div>

            <div key="no-results" class="text-center" v-else-if="!loading && noResults">
                <div class="alert alert-warning ">
                    <span class="h5">Записи не найдены</span>
                </div>
            </div>

            <div key="spinner" class="text-center" v-else>
                <b-spinner variant="secondary" class="mt-4" />
            </div>

        </transition>

        <data-table-context-menu ref="contextMenu"
                                 :actions="rowActions"
                                 @context-menu-closed="onMenuClosed"
                                 @on-delete="showDestroyModal"/>


        <b-modal :id="name + '-visibility'">
            <template #modal-title>
              Видимость колонок
            </template>

            <div>
                <div>
                    <b-form-checkbox-group
                        v-model="visibleColumnNames"
                        :options="columns"
                        value-field="name"
                        text-field="title"
                        disabled-field="alwaysVisible"
                        @input="columnsVisibilityChanged"
                        stacked
                        switches>
                    </b-form-checkbox-group>
                </div>
            </div>

            <template #modal-footer>
                <b-button block @click="setAllColumnsVisible">Выбрать все</b-button>
            </template>

        </b-modal>

        <b-modal :id="destroyModalId" hide-header hide-footer centered>
            <data-table-destroy :object="selectedForDestroy"
                                :api-entry-point="apiViewSet"
                                @close="onDestroyCancel"
                                @object-deleted="onDestroyObject"/>
        </b-modal>

    </div>
</template>

<script>
    import axios from 'axios';
    import httpClient from "../../http";
    import { debounce } from 'debounce';
    import actions from "./actions";
    import { dragscroll } from 'vue-dragscroll';

    import Spinner from "../Spinner";

    import { mapGetters } from 'vuex';
    import { TableActions } from "@/store/tables/constants";

    import DataTablePagination from "./DataTablePagination";
    import DataTableSearch from "./DataTableSearch";
    import DataTableFilter from "./DataTableFilter";
    import DataTableAction from "./DataTableAction";
    import DataTableOrdering from "./DataTableOrdering";
    import DataTableEvents from "./events";
    import DataTableDateFilter from "./DataTableDateFilter";
    import DataTablePageSizeSelect from "./DataTablePageSizeSelect";
    import DataTableDateFromToFilter from "./DataTableDateFromToFilter";
    import LinkCell from "../../pages/DataTableCells/LinkCell";
    import ModalButtonCell from "../../pages/DataTableCells/ModalButtonCell";
    import DataTableContextMenu from "./DataTableContextMenu";
    import DataTableBooleanFilter from "@/components/Table/DataTableBooleanFilter";
    import DataTableDestroy from "@/components/Table/DataTableDestroy.vue";
    import EventBus from "@/bus";

    export default {
        name: "DataTable",
        components: {
            DataTableDestroy,
            DataTableBooleanFilter,
            DataTableContextMenu,
            ModalButtonCell,
            LinkCell,
            DataTablePageSizeSelect,
            DataTableDateFilter,
            DataTableOrdering,
            DataTableSearch,
            DataTablePagination,
            DataTableFilter,
            DataTableAction,
            DataTableDateFromToFilter,
            Spinner,
        },
        directives: {
            dragscroll
        },
        props: {
            name: { type: String },
            title: { type: String, default: null },
            apiRoute: { type: String },
            apiViewSet: { type: Object },
            columns: { type: Array },
            actions: { type: Array, default: () => { return [] } },
            rowActions: { type: Array, default: () => { return [] } },
            filters: { type: Array, default: () => { return [] } },
            initialFilters: { type: Object, default: () => { return {} } },
            orderings: { type: Array, default: () => { return [] } },
            initialOrderings: { type: Object, default: () => { return {} } },
            toggleRowComponent: { type: Object, default: () => { return {} } },
            search: false,
            searchPlaceholder:  { type: String, default: null },
            destroyTitle: { type: String },
            hasVisibilityAction: { type: Boolean, default: true },
            showSelectRowColumn: { type: Boolean, default: false },
        },
        data() {
            return {
                rows: [],
                pageCount: 0,
                filteredObjectsCount: 0,
                totalObjectsCount: 0,
                page: 1,

                searchTerm: '',
                appliedFilters: [],
                initialFiltersVisible: false,

                orderingValues: {},

                appliedOrderings: {},
                query: '',

                loading: false,

                visibleColumnNames: [],
                fixedColumnNames: [],

                selectedForDestroy: null,

                contextMenuSelectedRow: null,
                selectedKey: new Date().getTime(),

                searchFocused: false,
                actionsHidden: false,

                cancelTokenSource: null
            }
        },
        computed: {
            ...mapGetters(['getTableHiddenColumnNames', 'isColumnHidden', 'getTablePageSize', 'isColumnFixed',
                'getFilters', 'getStoredSearch', 'getStoredPage']),
            noResults() { return this.rows.length === 0 },
            events() { return DataTableEvents },
            actionEvents() {
                const allActions = [...this.actions, ...this.rowActions];
                let actionEvents = {};
                for (const i in allActions) {
                    const action = allActions[i];
                    actionEvents[action.name] = {
                        event: action.emittedEvent + '-' + this.name,
                        handler: action.handler
                    };
                }
                return actionEvents;
            },
            destroyModalId() {
                return 'delete-' + this.name;
            },
            getCheckboxHiddenColumnNames() {
                let cols = [];
                for (const i in this.columns) {
                    if (this.visibleColumnNames.indexOf(this.columns[i].name) < 0) {
                        cols.push(this.columns[i].name)
                    }
                }
                return cols;
            },
            getVisibleColumns() {
                let cols = [];
                for (const i in this.columns) {
                    if (this.getTableHiddenColumnNames(this.name).indexOf(this.columns[i].name) < 0) {
                        cols.push(this.columns[i])
                    }
                }
                return cols;
            },
            filtersDomId() {
                return this.name + '-filters';
            },

        },
        methods: {
            getCellStyle(i) {
                if (i % 2 === 0) { return }
                const row = this.rows[(i - 1)/2];
                const rowColor = row['row_color'];
                const selectedRowColor = row['selected_row_color'];
                function _checkColor(colorStr) {
                    return colorStr && (colorStr.length === 4 || colorStr.length === 7) && colorStr.startsWith('#')
                }
                const rowHasCustomColor = _checkColor(rowColor)
                const rowHasCustomSelectedColor = _checkColor(selectedRowColor)
                let style = ''
                if (rowHasCustomColor) {
                    style += 'background-color: ' + rowColor + '; '
                }
                if (rowHasCustomSelectedColor && row.selected) {
                    style += 'background-color: ' + selectedRowColor + '; '
                }
                return style
            },
            showObjectModal(modalName, objectId) {
                this.$emit('object-modal-triggered', modalName, objectId);
            },
            getRowColumnNameValue(row, columnName, leaveBlank=false, raw=false) {
                let value = '';
                let attrs = columnName.split('.');
                let v = row;
                for (const i in attrs) {
                    const attr = attrs[i];
                    if (v === undefined || v === null || v === '' || v && !v.hasOwnProperty(attr)) {
                        if (!leaveBlank) { return '—' }
                        else { return '' }
                    }
                    value = v[attr];
                    v = value;
                }

                if (!raw) {
                    if (Array.isArray(value)) {
                        value = value.join(', ')
                    }
                    if ((v === undefined || v === null || v === '') && !leaveBlank) {
                        value = '—';
                    }
                }

                return value;
            },
            getRowColumnValue(row, column, leaveBlank=false, raw=false) {
                return this.getRowColumnNameValue(row, column.name, leaveBlank, raw);
            },
            getExtraPropsRowColumnValue(row, column, leaveBlank=false) {
              return column.extraProps ? column.extraProps : {}
            },
            getExtraRowColumnValue(row, column, leaveBlank=false) {
                const extras = column.extraDataFrom;
                let format = column.extraDataFormat;
                let raw = column.extraRaw;
                let extraValue = '';
                if (extras) {
                    if (Array.isArray(extras)) {
                        let extra = [];
                        for (const i in extras) {
                            let val = this.getRowColumnValue(row, {name: extras[i]}, leaveBlank, raw);
                            if (val) { extra.push(val) }
                        }
                        extraValue = raw ? extra : extra.join(', ');
                    } else {
                        extraValue = this.getRowColumnValue(row, {name: column.extraDataFrom}, leaveBlank, raw);
                    }
                }
                if (format && !raw && extraValue) { extraValue = format.replace('{{}}', extraValue) }
                return extraValue
            },

            onPageSizeChanged(e) {
                this.resetPage();
            },
            resetPage() {
                if (this.page === 1) {
                    this.setQuery();
                } else {
                    this.page = 1;
                }
            },
            onSearchTermChanged(searchTerm) {
                this.searchTerm = searchTerm;
                this.$store.dispatch(
                    TableActions.TABLE_CHANGE_SEARCH,
                    { name: this.name, search: this.searchTerm }
                );
                this.doSearch();
            },
            onSearchFocusChanged(focused) {
                this.searchFocused = focused;
            },
            doSearch: debounce(function() {
                this.resetPage();
            }, 800),

            onFilterAdded(name, value, label, parentFilterName, link, linkValue) {
                // console.log('Added ')
                // console.log(name, value, label, parentFilterName, link)
                const val = {value: value, key: name, label: label,
                    parentFilterName: parentFilterName, link: link, linkValue: linkValue}
                this.appliedFilters.push(val);
                this.resetPage();

                this.$store.dispatch(
                    TableActions.TABLE_CHANGE_FILTERS,
                    { name: this.name, filterData: this.appliedFilters }
                    );
            },
            onFilterRemoved(name, value, label, parentFilterName, link) {
                // console.log('Removed ')
                // console.log(name, value, label, parentFilterName, link)
                for (let i = 0; i < this.appliedFilters.length; i++) {
                    if (this.appliedFilters[i].key === name && (value && this.appliedFilters[i].value === value || !value)
                        || this.appliedFilters[i].link === name) {
                        this.appliedFilters.splice(i, 1);
                        i--;
                    }
                }
                this.resetPage();

                this.$store.dispatch(
                    TableActions.TABLE_CHANGE_FILTERS,
                    { name: this.name, filterData: this.appliedFilters }
                );
            },
            resetFilter(name, value, shouldSetQuery = true, parentFilterName = null, linkValue = null) {
                for (let i = 0; i < this.appliedFilters.length; i++) {
                    if (this.appliedFilters[i].value === value && this.appliedFilters[i].key === name
                        || this.appliedFilters[i].link === name && this.appliedFilters[i].linkValue === value) {
                        this.appliedFilters.splice(i, 1);
                        i--;
                    }
                }
                let ref = this.$refs[name];
                if (ref && ref.length && ref[0].hasOwnProperty('resetValue')) {
                    ref[0].resetValue(value)
                }
                if (parentFilterName) {
                    let ref = this.$refs[parentFilterName];
                    if (ref && ref.length && ref[0].hasOwnProperty('resetChildValue')) {
                        ref[0].resetChildValue(value, name)
                    }
                }
                if (shouldSetQuery) {
                    this.resetPage();
                }

                this.$store.dispatch(
                    TableActions.TABLE_CHANGE_FILTERS,
                    { name: this.name, filterData: this.appliedFilters }
                );

                this.$emit('filter-reset', name, value);
            },
            resetAllFilters() {
                this.appliedFilters = [];
                for (const k of Object.keys(this.$refs)) {
                    const ref = this.$refs[k]
                    if (ref && ref.length && ref[0].hasOwnProperty('reset')) {
                        ref[0].reset();
                    }
                }
                this.resetPage();

                this.$store.dispatch(
                    TableActions.TABLE_CHANGE_FILTERS,
                    { name: this.name, filterData: this.appliedFilters }
                );

                this.$emit('filter-reset');
            },

            getInitialFilter(filterName) {
                const storedFilters = this.getFilters(this.name);
                for (const filter of storedFilters) {
                    if (filter['key'] === filterName) {
                        return filter
                    }
                }
                return null;
            },

            getInitialFilters(filterName) {
                const storedFilters = this.getFilters(this.name);
                let initialFilters = [];
                for (const filter of storedFilters) {
                    if (filter['key'] === filterName) {
                        initialFilters.push(filter)
                    }
                }
                return initialFilters;
            },

            getInitialDateFromFilter(filterName) {
                const storedFilters = this.getFilters(this.name);
                for (const filter of storedFilters) {
                    if (filter['key'] === filterName + '_from') {
                        return filter
                    }
                }
                return null;
            },

            getInitialDateToFilter(filterName) {
                const storedFilters = this.getFilters(this.name);
                for (const filter of storedFilters) {
                    if (filter['key'] === filterName + '_to') {
                        return filter
                    }
                }
                return null;
            },

            getQueryString(start = true) {
                let queryString = '&';
                if (start) { queryString = '?' }

                let initialFilterStr = ''
                let initialFilterParts = [];
                for (const name in this.initialFilters) {
                    if (Array.isArray(this.initialFilters[name])) {
                        for (const i in this.initialFilters[name]) {
                            initialFilterParts.push(name + '=' + this.initialFilters[name][i]);
                        }
                    } else {
                        initialFilterParts.push(name + '=' + this.initialFilters[name]);
                    }
                }
                initialFilterStr = initialFilterParts.join('&');

                let appliedFilterStr = '';
                let appliedFilterParts = [];
                for (const f of this.appliedFilters) {
                    appliedFilterParts.push(f.key + '=' + f.value);
                }
                appliedFilterStr = appliedFilterParts.join('&');

                let searchStr = '';
                if (this.searchTerm) {
                    searchStr = 'search=' + this.searchTerm;
                }
                let orderStr = '';
                let orderStrParts = [];
                for (const name of Object.keys(this.appliedOrderings)) {
                    orderStrParts.push('order=' + this.appliedOrderings[name] + name);
                }
                orderStr = orderStrParts.join('&');

                let params = [initialFilterStr, appliedFilterStr, searchStr, orderStr].filter(x => x !== '')
                queryString = queryString + params.join('&')

                return queryString
            },
            setQuery() {
                let route = null;
                if (this.apiViewSet && typeof this.apiViewSet['list'] === 'function') {
                    route = this.apiViewSet.list()
                } else {
                    route = this.apiRoute;
                }
                let url = route + '?page=' + this.page + '&page_size=' + this.getTablePageSize(this.name);
                this.query = url + this.getQueryString(false);

                if (this.cancelTokenSource) {
                    this.cancelTokenSource.cancel('DataTable query set');
                    this.cancelTokenSource = null;
                }
                this.getData();
            },
            beforeGetData() {
                this.rows = [];
            },
            getData() {
                const vm = this;
                vm.loading = true;
                vm.cancelTokenSource = axios.CancelToken.source()
                vm.beforeGetData();
                httpClient.get(vm.query, { cancelToken: vm.cancelTokenSource.token })
                .then((response) => {
                    vm.rows = response.data['results'];
                    vm.page = response.data['page'];
                    vm.pageCount = response.data['total_pages'];
                    vm.filteredObjectsCount = response.data['count'];
                    vm.totalObjectsCount = response.data['total_objects_count'];

                    for (let row of vm.rows) {
                        row.selected = false
                    }

                    vm.loading = false;
                }).catch((reason) => {
                    // console.log(reason, axios.isCancel(reason))
                    if (!axios.isCancel(reason)) {
                        vm.rows = [];
                        this.$bvToast.toast('Не удалось загрузить данные таблицы',
                            {solid: true, noCloseButton: true, autoHideDelay: 5000, variant: 'danger'});
                        vm.loading = false;
                    }
                }).finally(() => {
                    // vm.loading = false;
                })
            },

            reload() {
                this.setQuery();
            },

            columnsVisibilityChanged() {
                this.$store.dispatch(
                    TableActions.TABLE_CHANGE_COLUMN_VISIBILITY,
                    { name: this.name, columns: this.getCheckboxHiddenColumnNames }
                    );
            },

            setAllColumnsVisible() {
                this.visibleColumnNames = [];
                for (const i in this.columns) {
                    const col = this.columns[i];
                    this.visibleColumnNames.push(col.name)
                }
                this.columnsVisibilityChanged()
            },

            showDestroyModal(row, object) {
                if (object && typeof object['objectLabel'] === "function"
                    && this.apiViewSet && typeof this.apiViewSet['detail'] === 'function') {
                    this.selectedForDestroy = object;
                    this.$bvModal.show(this.destroyModalId);
                } else {
                    this.$bvToast.toast('Невозможно удалить объект', {
                        noCloseButton: true,
                        solid: true,
                        autoHideDelay: 5000,
                        variant: 'danger'
                    });
                }
            },

            onDestroyObject() {
                this.reload();
                this.$bvToast.toast('Объект успешно удален', {
                    noCloseButton: true,
                    solid: true,
                    autoHideDelay: 5000,
                    variant: 'success'
                });
                this.$bvModal.hide(this.destroyModalId);
                this.$emit('object-delete-success')
            },

            updateRow(data) {  // Does not perform request. Uses passed data to update the row.
                if (!data.hasOwnProperty('id')) {
                    return;
                }

                let row;
                for (const i in this.rows) {
                    let r = this.rows[i];
                    if (r['id'] === data['id']) {
                        row = r;
                        break;
                    }
                }

                const keys = Object.keys(data);
                for (const k in keys) {
                    const key = keys[k];
                    if (row.hasOwnProperty(key)) {
                        row[key] = data[key];
                    }
                }

                this.$bvToast.show('');

            },
            onDestroyCancel() {
                this.$bvModal.hide(this.destroyModalId);
            },
            getOrderingFieldName(colName) {
                for (const ordering of this.orderings) {
                    if (typeof ordering === 'string' && ordering === colName) {
                        return colName;
                    }
                    if (typeof ordering === 'object' && ordering.hasOwnProperty(colName)) {
                        return ordering[colName];
                    }
                }
            },
            onOrderingLoaded(e, colName, fieldName) {
                if (this.orderingValues[colName] !== undefined && this.orderingValues[colName] > 0) {
                    this.appliedOrderings[fieldName] = this.orderingValues[colName] === 2 ? '-' : ''
                } else {
                    delete this.appliedOrderings[fieldName]
                }
            },
            onOrderingChanged(e, colName, fieldName) {
                this.onOrderingLoaded(e, colName, fieldName);
                this.setQuery();
            },
            openMenu(e, row) {
                for (let row of this.rows) {
                    row.selected = false
                }
                row.selected = true
                this.onToggleRowSelect();
                this.contextMenuSelectedRow = row;
                this.$refs.contextMenu.open(e, row);
            },

            onMenuClosed(row) {
                row.selected = false
                this.contextMenuSelectedRow = null;
            },
            getRowSelected(i) {
                return i % 2 !== 0 && this.rows[(i - 1)/2].selected
            },
            onToggleRowSelect() {
                this.selectedKey = new Date().getTime()
            },
            onToggleSelectAll(val) {
                for (let row of this.rows) {
                    row.selected = val
                }
                this.selectedKey = new Date().getTime()
            },
            getSelectedRowIds() {
                let selectedRowIds = []
                for (let row of this.rows) {
                    if (row.hasOwnProperty('id') && row.selected) {
                        selectedRowIds.push(row['id'])
                    }
                }
                return selectedRowIds
            },
            getVisibleFilters() {
                let visibleFilters = [];
                for (const filter of this.filters) {
                    if (!filter.hasOwnProperty('visibleCallback') || filter.visibleCallback(this.appliedFilters)) {
                        visibleFilters.push(filter)
                    }
                }
                return visibleFilters
            }

        },
        beforeMount() {
            this.page = this.getStoredPage(this.name);

            for (const i in this.columns) {
                const col = this.columns[i];
                if (col.cellComponentName && col.cellComponentPath) {
                    const path = col.cellComponentPath + col.cellComponentName;
                    this.$options.components[col.cellComponentName] =
                        () => import('../../../' + path + '.vue')
                }
            }
            if (this.toggleRowComponent) {
                if (this.toggleRowComponent.cellComponentName && this.toggleRowComponent.cellComponentPath) {
                    const path = this.toggleRowComponent.cellComponentPath + this.toggleRowComponent.cellComponentName;
                    this.$options.components[this.toggleRowComponent.cellComponentName] =
                        () => import('../../../' + path + '.vue')
                }
            }
        },
        mounted() {
            if (this.hasVisibilityAction && !this.actions.filter(x => { return x.name === 'visibility' }).length) {
                this.actions.push(
                    actions.setColVisibility(() => { this.$bvModal.show(this.name + '-visibility') })
                );
            }

            for (const ordering of this.orderings) {
                let colName = ordering;
                if (typeof ordering === 'object') {
                    colName = Object.keys(ordering).length ? Object.keys(ordering)[0] : null;
                }
                if (colName) {
                    this.orderingValues[colName] = this.initialOrderings[colName] !== undefined ? this.initialOrderings[colName] : 0;
                }
            }

            const storedFilters = this.getFilters(this.name);
            if (storedFilters && storedFilters.length) {
                this.appliedFilters = [...storedFilters];
                this.initialFiltersVisible = true
            }
            this.searchTerm = this.getStoredSearch(this.name);

            for (const colName of Object.keys(this.orderingValues)) {
                this.onOrderingLoaded(this.orderingValues[colName], colName, this.getOrderingFieldName(colName))
            }

            this.reload();

            for (const i in this.columns) {
                const col = this.columns[i];
                if (!this.isColumnHidden(this.name, col.name)) {
                    this.visibleColumnNames.push(col.name)
                }
            }
            this.$root.$off('bv::collapse::state');
            this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
                EventBus.$emit('on-collapse-changed-' + collapseId, collapseId, isJustShown)
            })
        },
        watch: {
            'page': {
                handler: function(newValue, oldValue) {
                    this.setQuery();
                    this.$store.dispatch(
                        TableActions.TABLE_SET_CURRENT_PAGE,
                        { name: this.name, page: this.page }
                        );
                },
                immediate: false
             },
        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .data-table {
        & td, th {
            border: 0 !important;
            padding: 0.5em 1em;
        }
    }

    table {
        table-layout: auto;
        font-size: 14px;
        border-collapse: separate; /* Don't collapse */
        border-spacing: 0;

        & tr {
            /*cursor: pointer;*/
        }
    }

    table thead th {
        vertical-align: middle;
        border-top: 1px solid $gray-400 !important;
        border-bottom: 1px solid $gray-400 !important;
        white-space: nowrap;
    }

    td {
        width: auto;
        display: table-cell;
        vertical-align: middle !important;
    }

    td.sticky,th.sticky {
        position: sticky;
        left: 0;
    }

    tr:nth-child(even) {
        & th, td {
            background-color: $gray-100;
        }

    }

    tr:nth-child(odd) {

        & th {
            background-color: $gray-200;
        }

        & td {
            background-color: white;
        }

    }

    th:last-child, td:last-child {

    }

    table tbody tr:first-child td {
        border-top: 0 !important
    }

    tr.selected {
        & td {
            background-color: lighten($info, 52%);
            /*transition: background-color .5s ease;*/
        }
    }

    .m-01 {
        margin: 0.1rem
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity .2s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .search-expand {
        flex: 1 0 auto;
        transition: flex 250ms linear;
    }

    .search-shrink {
        flex: 0.001 0 auto;
        transition: flex 250ms linear;
    }

    .search-focused-shrink {
        flex: 0 0 auto;
    }

    .search-focused-expand {

    }

</style>